/* VSPORT — comportements des sections « vs-* » */
(function () {
  if (window.__vsLoaded) return;
  window.__vsLoaded = true;
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Apparition douce au défilement
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.vs-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  // Images différées : chargées quand leur bloc approche de l'écran
  function initLazy(root) {
    var blocks = (root || document).querySelectorAll('[data-vs-lazy]');
    function load(block) {
      block.querySelectorAll('img[data-vs-src]').forEach(function (img) {
        if (img.getAttribute('data-vs-srcset')) img.setAttribute('srcset', img.getAttribute('data-vs-srcset'));
        img.setAttribute('src', img.getAttribute('data-vs-src'));
        img.removeAttribute('data-vs-src');
        img.removeAttribute('data-vs-srcset');
      });
    }
    if (!('IntersectionObserver' in window)) { blocks.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { load(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '250px 0px' });
    blocks.forEach(function (b) { io.observe(b); });
  }

  // Flèches des carrousels
  function initRails(root) {
    (root || document).querySelectorAll('[data-vs-rail-nav]').forEach(function (nav) {
      var rail = document.getElementById(nav.getAttribute('data-vs-rail-nav'));
      if (!rail) return;
      nav.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-dir') === 'prev' ? -1 : 1;
          rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
    });
  }

  // Vidéos YouTube chargées seulement au clic (site plus rapide)
  function initVideos(root) {
    (root || document).querySelectorAll('[data-vs-video]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-vs-video');
        if (!id || btn.querySelector('iframe')) return;
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        f.title = btn.getAttribute('aria-label') || 'Vidéo';
        btn.appendChild(f);
      });
    });
  }

  // Planning : met en avant le jour en cours
  function initToday(root) {
    var d = new Date().getDay(); // 0 = dimanche
    (root || document).querySelectorAll('.vs-day[data-day="' + d + '"]').forEach(function (el) {
      el.classList.add('is-today');
    });
  }

  // Barre fixe mobile : apparaît après le premier écran
  function initSticky() {
    var bar = document.querySelector('.vs-sticky');
    if (!bar) return;
    document.body.classList.add('vs-has-sticky');
    var ticking = false;
    var footer = document.querySelector('.footer, footer');
    function update() {
      var show = window.scrollY > Math.min(420, window.innerHeight * 0.55);
      // Position du bas de page lue seulement si la barre doit s'afficher (évite un calcul de toute la page au chargement)
      if (show && footer && footer.getBoundingClientRect().top < window.innerHeight - 40) show = false;
      bar.classList.toggle('is-visible', show);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    // Lecture de la position seulement après le premier affichage (window.scrollY force un calcul de mise en page)
    window.requestAnimationFrame(function () { if (window.scrollY > 0) update(); });
  }

  // Aperçu uniquement (thème non publié) : tant que les nouvelles pages n'existent pas
  // dans Shopify, on affiche leur modèle sur une page existante (?view=...).
  // Ne fait plus rien une fois le thème publié.
  function initPreviewLinks() {
    var t = window.Shopify && window.Shopify.theme;
    if (!t || t.role === 'main') return;
    var map = {
      'nos-cours-collectifs': 'vs-cours', 'mal-de-dos': 'vs-dos', 'fatigue-constante': 'vs-fatigue',
      'manque-d-endurance': 'vs-endurance', 'baisse-de-motivation': 'vs-motivation', 'les-coachs': 'les-coachs'
    };
    ['bike', 'v-rox', 'v-energy', 'pump', 'body-sculpt', 'functional', 'caf', 'pilates', 'abdos-stretching'].forEach(function (h) {
      map['cours-' + h] = 'vs-cours-' + h;
    });
    document.querySelectorAll('a[href*="/pages/"]').forEach(function (a) {
      var m = a.getAttribute('href').match(/\/pages\/([a-z0-9-]+)/);
      if (m && map[m[1]]) a.setAttribute('href', '/pages/nos-formules-daccompagnement?view=' + map[m[1]]);
    });
  }

  // En-tête : ombre au défilement + menu mobile
  function initHeader() {
    var header = document.querySelector('[data-vs-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.requestAnimationFrame(onScroll);
    var drawer = header.querySelector('[data-vs-drawer]');
    var openBtn = header.querySelector('[data-vs-menu-open]');
    if (!drawer || !openBtn) return;
    function open() {
      drawer.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('vs-menu-open');
      var c = drawer.querySelector('[data-vs-menu-close]');
      if (c) c.focus();
    }
    function close() {
      drawer.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('vs-menu-open');
      openBtn.focus();
    }
    openBtn.addEventListener('click', open);
    drawer.querySelectorAll('[data-vs-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  // Mesure : chaque clic sur un bouton d'action est envoyé aux outils de statistiques
  // (Shopify « événements client » et Google, si le visiteur a accepté les cookies).
  function initTracking() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a, button');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var type = null;
      if (href.indexOf('tel:') === 0) type = 'appel';
      else if (href.indexOf('prendre-un-rendez-vous') > -1 || href === '#calendrier') type = 'bilan';
      else if (href.indexOf('offre-exclusive') > -1) type = 'offre';
      else if (a.hasAttribute('data-vs-video')) type = 'video';
      if (!type) return;
      var zone = a.closest('.vs-sticky') ? 'barre-mobile' : a.closest('.vs-header') ? 'en-tete' : a.closest('.vs-footer') ? 'bas-de-page' : 'page';
      var data = { type: type, zone: zone, texte: (a.textContent || '').trim().slice(0, 60), page: location.pathname + location.search };
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('vsport_clic', data); } catch (err) {}
      try { if (typeof window.gtag === 'function') window.gtag('event', 'vsport_clic_' + type, { zone: zone, page_path: data.page }); } catch (err) {}
    }, true);
  }

  function initAll(root) {
    initReveal(root);
    initLazy(root);
    initRails(root);
    initVideos(root);
    initToday(root);
  }

  onReady(function () {
    initAll(document);
    initSticky();
    initHeader();
    initTracking();
    initPreviewLinks();
  });

  // Éditeur de thème Shopify : réinitialise une section modifiée
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
